/* event-card.js
   Whole-card click delegate for snippets/snippet-event-card.liquid.

   This lived in an inline <script> inside the snippet behind an
   {% unless snippet_event_card_script_rendered %} guard. That guard could never
   fire, for the same reason the style guard could not: every call site renders
   the snippet inside a {% for %} loop via {% render %}, and {% render %} isolates
   variable scope per call, so one identical document-level listener was attached
   per card rather than per page.

   The window flag below does the job the Liquid guard could not, and it holds
   even if more than one section on the page loads this file. */
(function () {
  if (window.__slhubEventCardClickDelegate) return;
  window.__slhubEventCardClickDelegate = true;

  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-card-url]');
    if (!card) return;
    if (e.target.closest('a')) return;
    window.location.href = card.getAttribute('data-card-url');
  });
})();
